<script lang="ts" setup>
import type { ImportedDataListItem } from '@modules/imported-data/types';
import type { ITableColumnsOptions } from '@modules/tables/types';
import VIconButton from '@components/buttons/VIconButton/VIconButton.vue';
import VCard from '@components/card/VCard/VCard.vue';
import { useRestClient } from '@modules/core/services/api';
import { IMPORTED_DATA_PERMISSIONS, TRANSLATION_GROUPS_OF_IMPORTED_DATA } from '@modules/imported-data/constants';
import { useDownloadImportedDataMutation } from '@modules/imported-data/mutations';
import { useImportedDataListQuery } from '@modules/imported-data/queries';
import VTable from '@modules/tables/components/VTable/VTable.vue';
import { useTableData } from '@modules/tables/composables';

const { openLink } = useRestClient();

const {
  data,
  isLoading: isLoadingData,
  isFetching,
  tableState,
  updateTableState,
  refreshTableData,
} = useTableData(useImportedDataListQuery);

const columnOptions: ITableColumnsOptions = {
  aasm_state: {
    localization: {
      translationPath: 'admin.settings.imported_data.aasm_state.',
    },
  },
  name: {
    defaultMobilePreview: true,
  },
};

const {
  mutateAsync: onDownload,
  isLoading: isDownload,
} = useDownloadImportedDataMutation();

async function downloadImportedData(listItem: ImportedDataListItem): Promise<void> {
  const { link } = await onDownload(listItem.id);
  openLink(link);
}
</script>

<template>
  <VCard v-data-qa-auto-id="'ImportedDataPage'" type="table">
    <VTable
      :data="data"
      :state="tableState"
      :loading="isLoadingData"
      :is-fetching="isFetching"
      :title-t-path="$getTPath(TRANSLATION_GROUPS_OF_IMPORTED_DATA, 'HEADER')"
      :columns-options="columnOptions"
      @state-update="updateTableState"
      @refresh="refreshTableData"
    >
      <template #recordAction="{ listItem }">
        <VIconButton
          v-if="$hasPermission(IMPORTED_DATA_PERMISSIONS.SHOW)"
          icon="pi-download"
          :disabled="isDownload"
          @click="downloadImportedData(listItem)"
        />
      </template>
    </VTable>
  </VCard>
</template>
